import { __decorate } from "tslib";
import { lazyAppContextConsumer, lazyConsumer } from '@1inch-community/core/lazy';
import { animationMap, appendClass, appendStyle, dispatchEvent, observe, subscribe, } from '@1inch-community/core/lit-utils';
import { buildTokenIdByToken } from '@1inch-community/sdk/tokens';
import '@1inch-community/ui-components/button';
import '@1inch-community/ui-components/icon';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { BehaviorSubject, defer, fromEvent, map, shareReplay, tap } from 'rxjs';
import '../../../shared-elements/token-list';
import { selectTokenContext } from '../../context';
import { FavoriteTokensAnimationMapController } from './favorite-tokens-animation-map.controller';
import { favoriteTokensStyles } from './favorite-tokens.styles';
let FavoriteTokensElement = class FavoriteTokensElement extends LitElement {
    constructor() {
        super(...arguments);
        this.context = lazyConsumer(this, { context: selectTokenContext });
        this.applicationContext = lazyAppContextConsumer(this);
        this.editAllMode$ = new BehaviorSubject(false);
        this.scrollContainerRef = createRef();
        this.favoriteTokensAnimationMapController = new FavoriteTokensAnimationMapController((token, event) => this.onRemoveFavoriteToken(token, event), (token) => this.onSelectToken(token), () => this.onEditAllToggle());
        this.favoriteTokenList$ = defer(() => this.applicationContext.value.tokenStorage.liveQuery(() => this.applicationContext.value.tokenStorage.getAllFavoriteTokens()));
        this.favoriteTokensView$ = this.favoriteTokenList$.pipe(map((tokens, index) => {
            appendClass(this, {
                empty: tokens.length === 0,
                'transition-host': index > 0,
            });
            appendStyle(this, {
                height: `${tokens.length === 0 ? 16 : 60}px`,
            });
            return html `
        <div ${ref(this.scrollContainerRef)} class="favorite-container-scroll">
          <div class="favorite-container">
            ${animationMap(tokens, this.favoriteTokensAnimationMapController)}
          </div>
        </div>
      `;
        }), shareReplay({ bufferSize: 1, refCount: true }));
    }
    static { this.tagName = 'inch-favorite-tokens'; }
    static { this.styles = [favoriteTokensStyles]; }
    firstUpdated() {
        subscribe(this, [
            this.editAllMode$.pipe(tap((state) => {
                appendClass(this, {
                    'remove-favorite-token-show': state,
                });
            })),
            fromEvent(this, 'wheel').pipe(tap((event) => {
                if (!this.scrollContainerRef.value)
                    return;
                const element = this.scrollContainerRef.value;
                element.scrollLeft += event.deltaY;
            })),
        ], { requestUpdate: false });
    }
    render() {
        return html `${observe(this.favoriteTokensView$)}`;
    }
    onSelectToken(token) {
        this.context.value.onSelectToken(token);
        dispatchEvent(this, 'backCard', null);
    }
    onEditAllToggle() {
        this.editAllMode$.next(!this.editAllMode$.value);
    }
    async onRemoveFavoriteToken(token, event) {
        event.stopPropagation();
        event.preventDefault();
        const id = buildTokenIdByToken(token);
        await this.applicationContext.value.tokenStorage.changeFavoriteToken(id, false);
    }
};
FavoriteTokensElement = __decorate([
    customElement(FavoriteTokensElement.tagName)
], FavoriteTokensElement);
export { FavoriteTokensElement };
//# sourceMappingURL=favorite-tokens.element.js.map